(function($){
	const a = 'is-active';
	const o = 'is-open';
	const h = 'is-hidden';
	const v = 'is-visible';
	const breakpoint = 768;
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/index/common/svg/sprite.svg#arrow_left" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/index/common/svg/sprite.svg#arrow_right" /></svg></button>';

	const localDecision = () => {
		const siteName = 'nisshin';
		var regExp = new RegExp(`(test\\.${siteName}\\.com|copre\\.jp|localhost|192\\.168\\.0\\.|192\\.168\\.11\\.|192\\.168\\.1\\.)`, 'g');
		return regExp.test(location.hostname);
	};
	const localLoading = () => {
		// ローカル環境ならincludeをAjaxで読み込む
		let key = 'inc_';
		let ajaxArray = [];
		let ajaxArrayList = [];
		let i, j;
		let includeClass = document.querySelectorAll(`[class*="${key}"]`);
		let includeClassLen = includeClass.length;

		for (i = 0; i < includeClassLen; i++) {
			let path = includeClass[i].innerHTML.split(' ')[1];
			ajaxArray.push(path);
		}
		let ajaxLen = ajaxArray.length;

		if (ajaxLen > 0) {
			for (i = 0; i < ajaxLen; i++) {
				ajaxArrayList[i] = $.ajax({
					type: 'GET',
					url: ajaxArray[i] + '.html',
					dataType: 'html',
					timeout: 5000
				});
			}
			$.when.apply($, ajaxArrayList).done((...args) => {
				let regExp = new RegExp(key);

				for (i = 0; i < args.length; i++) {
					let result = args[i];
					let position = $(result[0]).filter(':first').attr('class').split(' ');

					for (j = 0; j < position.length; j++) {
						if (position[j].match(regExp)) {
							position = position[j];
							break;
						}
					}
					$('.' + position).html(result[0]).children().unwrap();

					console.log('Succeeded to read the include file!:', position);
				}
				loadDelayScript();
			});
		} else {
			loadDelayScript();
		}
	};

	// -------------------------------------------------------------------------------- //
	// <共通>JSON
	const getJSONrecipeDetail = (_recipeID) => {
		return $.getJSON(`/index/recipe/ajax/recipe/recent/${_recipeID}.json`);
	}

	// ＜検索フォーム＞検索フォーム絞り込み部分開閉
	const searchFormSwitch = () => {
		$('.recipe-search__detailSearch .__switch').on('click', (e) => {
			e.preventDefault();
			$(e.currentTarget).toggleClass(o);
			$('.recipe-search__detailSearch .__body').slideToggle(400);
		});
	};
	// ＜検索フォーム＞SPで検索フォーム絞り込みの各項目を開閉
	const searchFormSwitchDetailSP = () => {
		const $list = $('.__table-head.sp-switch');
		$list.each((idx, val) => {
			$(val).on('click', () => {
				$(val).parent('.__table').toggleClass(o);
				$(val).next('.__table-body').slideToggle(200);
			});
		});
	};
	// ＜検索フォーム＞主食：パスタが選択されたときに詳細項目を表示する
	const searchFormCatActivate = () => {
		const setActivate = () => {
			if ($('#staple_2').prop('checked')) {
				$('[data-category="pasta"]').addClass(a);
			} else {
				$('[data-category="pasta"]').find('input[type="checkbox"]').prop('checked', false);
				$('[data-category="pasta"]').removeClass(a);
			}
		}
		setActivate();
		$('#staple_2').change(() => {
			setActivate();
		});
	};
	// ＜検索フォーム＞リセットボタン処理
	const searchFormReset = () => {
		$('.js-searchReset').on('click', () => {
			$('.recipe-search__txtSearch').find('input[type="text"]').val('');
			$('.recipe-search__detailSearch').find('input[type="checkbox"]').each((idx, val) => {
				$(val).prop('checked', false);
			});
			$('[data-category="pasta"]').removeClass(a);
			$('.recipe-search__detailSearch').find('select').each((idx, val) => {
				$(val).val('');
			});
			$('html, body').animate({ scrollTop: 0 }, '400', 'swing');
		});
	};
	// <検索フォーム>入力したキーワードをkeywords_for_tagに反映
	const searchFormKeyword = () => {
		$('.js-keywordInput').on('input', (e) => {
			let thisVal = $(e.currentTarget).val();
			$('.js-keywordInput-hidden').attr('value', thisVal);
			// $('.js-keywordInput-kuromoji').attr('value', thisVal);
		});
	};
	// <検索フォーム> 入力されたキーワードを形態素解析
	const searchFormKuromoji = () => {
		if($('.js-keywordInput').length) {
			const $input = $('.js-keywordInput');
			const $hiddenInput = $('.js-keywordInput-kuromoji');
			const $submit = $('.js-submit');
			const $form = $('.js-searchForm')
			let searchKeyword = $('input[name="keywords_for_tag"]').val();
			
			// 初期表示
			$input.val(searchKeyword);
			// キーワード入力時にフォーム送信停止
			$input.on('input', (e) => {
				$submit.attr('type', 'button');
			});

			const kuromojiSet = () => {
				let $val = $input.val();
				let names = [];
				let removals = [' ','　'];
				
				kuromoji.builder({dicPath: '/index/common/js/kuromoji/dict/'}).build((err, tokenizer) => {
					// ここで解析を行う
					const tokens = tokenizer.tokenize($val);// 解析データの取得
					tokens.forEach((token)=>{// 解析結果を順番に取得する
						names.push(token.surface_form);
					});
					// スペースを削除
					names = names.filter(function(v){
						return ! removals.includes(v);
					});
					$hiddenInput.attr('value', names.join('　'));
					// フォーム送信
					$submit.attr('type', 'submit');
					$form.submit();
				});
			}
			// 検索ボタンクリックで送信
			$submit.on('click', (e) => {
				kuromojiSet();
			});
			// エンターキーで送信
			$input.on('keydown', (e) => {
				if (e.keyCode === 13) {
					kuromojiSet();
				}
			});

		}
	};
	// ＜検索結果＞選択項目からラベル作成
	const searchResultSetLabel = () => {
		if(location.search) {
			let appendHTML = '';
			let param = location.search.slice(1);
			let paramArr = param.split('&');
			for (let i = 0; i < paramArr.length; i++) {
				if(paramArr[i].split('=')[1] !== '') {
					if (paramArr[i].split('=')[0] === 'tag') {
						// タグ検索
						appendHTML +=
							`<li><span data-name="${paramArr[i].split('=')[0]}" data-key="${$(`.rt_cf_tag[data-tagkey="${paramArr[i].split('=')[1]}"]`).text()}">` +
							$(`.rt_cf_tag[data-tagkey="${paramArr[i].split('=')[1]}"]`).text() + '<i class="js-labelClose">×</i></span></li>';

					} else if (paramArr[i].split('=')[0] === 'category') {
						// 商品から探す
						appendHTML +=
							`<li><span data-name="${paramArr[i].split('=')[0]}" data-key="${decodeURIComponent(paramArr[i].split('=')[1])}">` +
							decodeURIComponent(paramArr[i].split('=')[1]) + '<i class="js-labelClose">×</i></span></li>';

					} else if (paramArr[i].split('=')[0] === 'product_id') {
						// product_idは反映しない

					} else if (paramArr[i].split('=')[0] === 'product_category_name') {
						// 商品から探す
						appendHTML +=
							`<li><span data-name="${paramArr[i].split('=')[0]}" data-key="${decodeURIComponent(paramArr[i].split('=')[1])}">使用している商品：` +
							decodeURIComponent(paramArr[i].split('=')[1]) + '<i class="js-labelClose">×</i></span></li>';

					} else if (paramArr[i].split('=')[0] === 'product_name') {
						// 商品から探す
						appendHTML +=
							`<li><span data-name="${paramArr[i].split('=')[0]}" data-key="${decodeURIComponent(paramArr[i].split('=')[1])}">` +
							decodeURIComponent(paramArr[i].split('=')[1]) + '<i class="js-labelClose">×</i></span></li>';

					} else if (paramArr[i].split('=')[0] === 'rt_bn_recipe_skip'){
						// ページャーは反映しない

					} else if (paramArr[i].split('=')[0] === 'keywords' || paramArr[i].split('=')[0] === 'keywords_for_tag'
						|| paramArr[i].split('=')[0] === 'id' || paramArr[i].split('=')[0] === 'user'
						|| paramArr[i].split('=')[0] === 'snapshotdate' || paramArr[i].split('=')[0] === 'appkey') {
						// キーワードとプレビュー用パラメータは反映しない
						// $('.recipe-result__narrow').addClass(h);

					} else if (paramArr[i].split('=')[0] === 'group') {
						$('.recipe-result__narrow').addClass(h);
						// グループはキーワードに反映
						$('.mod-input[name="keywords"]').val(decodeURIComponent(paramArr[i].split('=')[1]));

					} else if (paramArr[i].split('=')[0] === 'cooking_time' ||
						paramArr[i].split('=')[0] === 'energy' ||
						paramArr[i].split('=')[0] === 'salinity') {
						// select系
						appendHTML +=
						`<li><span data-name="${paramArr[i].split('=')[0]}" data-key="${paramArr[i].split('=')[1]}">` +
						$(`[value="${paramArr[i].split('=')[1]}"]`).text() + '<i class="js-labelClose">×</i></span></li>';

					} else if (paramArr[i].split('=')[0] !== 'rt_jbn_recipe_skip') {
						// チェックボックス系
						appendHTML +=
						`<li><span data-name="${paramArr[i].split('=')[0]}" data-key="${paramArr[i].split('=')[1]}">`;
						if ($(`[value="${paramArr[i].split('=')[1]}"]`).next('label').attr('data-parent')) {
							appendHTML += `${$(`[value="${paramArr[i].split('=')[1]}"]`).next('label').attr('data-parent')}：`;
						}
						appendHTML += $(`[value="${paramArr[i].split('=')[1]}"]`).next('label').text() +
							'<i class="js-labelClose">×</i></span></li>';

						if(paramArr[i].split('=')[0] === 'staplefood' && paramArr[i].split('=')[1] === 's_konamono') {
							$('.js-okotakoBasic').removeClass('di_none');
						}

						if(paramArr[i].split('=')[0] === 'staplefood' && paramArr[i].split('=')[1] === 's_konamono') {
							$('.js-sdgs').removeClass('di_none');
						}
					}
				}
			}
			if(appendHTML) {
				$('.js-searchLabels').append(appendHTML);
			} else {
				$('.recipe-result__narrow').addClass(h);
			}

			// 各ラベルの✕クリック時、条件を除外して再検索
			$('.js-labelClose').each((idx, val) => {
				$(val).on('click', () => {
					let $thisLabel = $(val).parent('span');
					let newParam = '';

					if($thisLabel.attr('data-name') === 'product_category_name' || $thisLabel.attr('data-name') === 'product_name') {
						location.href = '/index/recipe/search.html';
					} else {

						for (let i = 0; i < paramArr.length; i++) {
							if (paramArr[i] !== `${$thisLabel.attr('data-name')}=${$thisLabel.attr('data-key')}` &&
								paramArr[i] !== `${$thisLabel.attr('data-name')}=${encodeURIComponent($thisLabel.attr('data-key'))}`) {
								if (`${$thisLabel.attr('data-name')}=${$thisLabel.attr('data-key')}` === 'staplefood=s_pasta') {
									// パスタを除外したときはパスタソース・種類も除外
									if (paramArr[i].split('=')[0] !== 'pastasauce' && paramArr[i].split('=')[0] !== 'pastatype') {
										newParam += `${paramArr[i]}&`;
									}
								} else {
									newParam += `${paramArr[i]}&`;
								}
							}
						}
						newParam = newParam.slice(0, -1);
						location.href = `/index/recipe/search.html?${newParam}`;
					}
				});
			});
		} else {
			$('.recipe-result__narrow').addClass(h);
		}
	};
	// ＜検索結果＞0件表示
	const searchResultNoHit = () => {
		if(!$('.recipe-list1').find('li').length) {
			$('.recipe-result').css('display', 'none');
			$('.recipe-result__nohit').css('display', 'block');
			$('.recipe-result__nohit-bottom').addClass(v);
			searchByProduct();
			if ($(window).width() <= 768) { searchProdSwicthSP(); }
		} else {
			$('.recipe-result__nohit-bottom').remove();
		}
	};
	// ＜検索結果＞並び替え
	const searchResultSetSort = () => {
		let thisSearch = location.pathname.split('/')[3].replace(/\.html/, '');
		$('.js-searchSort').val(thisSearch);

		$('.js-searchSort').on('change', (e) => {
			let param = location.search.slice(1);
			let paramArr = param.split('&');
			let newParam = '';
			for (let i = 0; i < paramArr.length; i++) {
				if (paramArr[i].split('=')[0] !== 'rt_jbn_recipe_skip') {
					newParam += `${paramArr[i]}&`;
				}
			}
			newParam = newParam.slice(0, -1);
			location.href = `/index/recipe/${$(e.currentTarget).val()}.html?${newParam}`;
		});
	};
	// ＜検索結果＞レシピ一覧までスクロール
	const searchResultScroll = () => {
		if(location.search) {
			var pos = $('#recipeList').offset().top;

			if(NSFD.va.window.width < NSFD.va.device.sp) {
				pos -= 90;
			} else {
				pos -= 60;
			}
			$('html,body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
		}
	};
	// ＜検索結果＞もっと見る
	const recipeListMore = () => {
		const $recipeList = $('.js-recipeList li');
		if($recipeList.length) {
			let startCnt = 0, endCnt = 24;
			const addResult = () => {
				for(let i=startCnt; i<endCnt; i++) {
					if($recipeList.eq(i).length) {
						$recipeList.eq(i).addClass(v);
						$('.js-recipeList-more').removeClass('di_none');
					} else {
						$('.js-recipeList-more').addClass('di_none');
						break;
					}
				}
			};
			// 最初の24件表示
			addResult();
			if($recipeList.length <= 24) {
				$('.js-recipeList-more').addClass('di_none');
			}
			// moreボタン押下で24件ずつ追加表示
			$('.js-recipeList-more').on('click', () => {
				startCnt += 24; endCnt += 24;
				addResult();
			});
		}
	};

	// <検索結果>レシピ検索結果取得用
	const getJSONrecipeResult = (_param) => {
		return $.getJSON(`/index/recipe/ajax/recipe/search.json${_param}`);
	};
	// <検索結果>レシピ検索結果描画
	const recipeResultPriority = () => {
		let $param = location.search;
		let tagArr = [];
		// 主食タグ
		if($('.js-resultPriority-tag').find('.rt_cf_tag').length) {
			$('.js-resultPriority-tag').find('.rt_cf_tag').each((idx, ele) => {
				let thisCode = $(ele).attr('data-rt_code');
				tagArr.push(thisCode);
			});
		}

		let recipeListA = '';
		let recipeListB = '';

		getJSONrecipeResult($param).then((data) => {
			let recipeData = data.rt_bn_recipe;
			
			$('.js-total').text(data.total);
			if(recipeData.length) {
				for(let i = 0; i < recipeData.length; i++) {
					let thisName = recipeData[i].cf_r_title;
					let thisUrl = recipeData[i].rt_cf_detail_page_url.href;
					let thisImg = recipeData[i].rt_cf_thumbnail.src;
					let thisTime = recipeData[i].cf_r_cooking_time;
					let thisEnergy = recipeData[i].cf_r_energy;
					let thisSalinity = recipeData[i].cf_r_salinity;
					let thisThemes = recipeData[i].cf_r_themes;
					let thisStaplefood = recipeData[i].cf_r_staple_foods;
					let resultStaplefood = [];
					let themesHtml = '';

					if(thisStaplefood !== null) {
						if(thisStaplefood.length > 0) {
							for(let j = 0; j < thisStaplefood.length; j++) {
								if(tagArr.indexOf(thisStaplefood[j]._key) !== -1) {
									resultStaplefood.push(thisStaplefood[j]._key);
								}
							}
						}
					}
					if(thisThemes !== null) {
						if(thisThemes.length > 0) {
							themesHtml += '<div class="__tagList">'
							for(let k=0; k<thisThemes.length; k++) {
								let thisThemeName = thisThemes[k].cf_t_name;
								themesHtml += `<span class="__tag">${thisThemeName}</span>`;
							}
							themesHtml += '</div>';
						}
					}

					let infoHtml = '<div class="__item_info">';
					let recipeHtml;
					if(thisTime !== null) { // 「調理時間」
						infoHtml += '<span class="__item_info-time"><svg class="icon">'+
						'<use xlink:href="/index/common/svg/sprite.svg#time"></use></svg><span>'+thisTime+'</span>分</span>';
					}
					if(thisEnergy !== null) { // 「エネルギー」
						infoHtml += '<span class="__item_info-cal"><svg class="icon">'+
						'<use xlink:href="/index/common/svg/sprite.svg#cal"></use></svg><span>'+thisEnergy+'</span>kcal</span>';
					}
					if(thisSalinity !== null) { // 「塩分量」
						infoHtml += '<span class="__item_info-salt"><svg class="icon">'+
						'<use xlink:href="/index/common/svg/sprite.svg#salt"></use></svg><span">'+thisSalinity+'</span>g</span>';
					}
					infoHtml += '</div>';
					// 「調理時間」「エネルギー」「塩分量」全部nullの場合は空にする
					if(thisTime === null && thisEnergy === null && thisSalinity === null) {
						infoHtml = '';
					}
					recipeHtml = '<li class="__item js-create-item">'+
					'<a href="'+thisUrl+'">'+
					'<div class="__item_img">'+
					'<img src="'+thisImg+'" alt="'+thisName+'" title="'+thisName+'">'+
					'</div><div class="__item_txt">'+
					'<p class="__item_name">'+thisName+'</p>'+
					infoHtml + themesHtml +'</div></a></li>';

					if(resultStaplefood.length > 0) {
						// 主食コードが一致するものがある場合をリストAとする（検索結果上部に表示する）
						recipeListA += recipeHtml;
					} else {
						// 主食コードが一致するものが無い場合をリストBとする
						recipeListB += recipeHtml;
					}
				}
			} else {
				// 0件メッセージ表示
				$('.recipe-search-loading').animate({
					opacity: 0 }, 100).delay(150).queue(function(next){
					$('.recipe-search-loading').addClass(h);
					next();
				});
				$('.js-total-wrap').addClass(v);
				$('.js-result-head').addClass(v);
				searchResultNoHit();
			}
		}).done(() => {
			$('.js-recipeList .recipe-list1').append(recipeListA + recipeListB);
			$('.js-total-wrap').addClass(v);
			$('.js-recipeList-more').addClass(v);
			$('.js-result-head').addClass(v);
			$('.recipe-search-loading').animate({
				opacity: 0 }, 100).delay(150).queue(function(next){
				$('.recipe-search-loading').addClass(h);
				next();
			});
			recipeListMore();
		});
	};

	// ＜レシピTOP＞特集のdata-visible="0"の要素を削除
	const removeFeatureNonvisible = () => {
		if ($('.recipe-idx-feature').length) {
			$('.recipe-idx-feature').find('.cf_rf_used_products').each((idx, val) => {
				if($(val).find('img').attr('data-visible') === '0') {
					$(val).remove();
				}
			});
		}
	};
	// ＜レシピTOP＞SPのみ「商品から探す」もっと見るボタン
	const searchProdSwicthSP = () => {
		$('.recipe-idx-searchProd__switch').on('click', (e) => {
			$(e.currentTarget).toggleClass(o);
			$('[data-area="spclose"]').each((idx, val) => {
				$(val).toggleClass(o);
			});
		});
	};
	// ＜レシピTOP＞新着レシピが空の場合項目を削除
	const removeNewArrivelRecipes = () => {
		if (!$('.recipe-idx-arrival .recipe-list1').find('li').length) {
			$('.recipe-idx-arrival').remove();
		}
	};
	// <レシピTOP>新着レシピslide
	const newArrivelRecipesSlide = () => {
		if($('#new.recipe-idx-arrival .recipe-list1 .__item').length > 2) {
			$('#new.recipe-idx-arrival').find('.recipe-list1').slick({
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				arrows: true,
				dots: false,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							appendArrows: $('.recipe-list1_arrows'),
						}
					}
				]
			});
		}
 	};
 	// <レシピTOP> 商品から探す
 	const searchByProduct = () => {
 		const getJSONsearchByProductList = (_id) => {
			return $.getJSON(`/index/recipe/ajax/recipe/${_id}/product_id.json`);
		};
		$('.recipe-idx-searchProd li').each((idx, ele) => {
			let prodCatName = $(ele).find('.__text').text();
			let prodCatList = $(ele).find('a').attr('data-cat');
			let prodIdList = prodCatList.split('&');
			let setParam = '/index/recipe/search.html';

			for(let i = 0; i < prodIdList.length; i++) {
				let thisID = prodIdList[i];
				getJSONsearchByProductList(thisID).then((data) => {
					let prodData = data.rt_bn_product;
					if (prodData.length) {
						for(let j = 0; j < prodData.length; j++) {
							let prodId = prodData[j].rt_cf_product_id;
							if(i === 0 && j === 0) {
								setParam += '?product_id=' + prodId;
							} else if(i === prodIdList.length -1 && j === prodData.length -1) {
								setParam += '&product_id=' + prodId +
								'&product_name='+ encodeURIComponent(prodCatName);
							} else {
								setParam += '&product_id=' + prodId;
							}
						}
						$(ele).find('a').attr('href', setParam).addClass(v);
					}
				});
			}
		});
 	};
	// ＜レシピ詳細＞JSON-LD出力
	const setJsonld = () => {
		let appendSrc =
			'{"@context": "https://schema.org/", "@type": "Recipe",' +
			`"name": "${$('.jsonld_name').text()}",` +
			`"image": "https://www.nisshin-seifun-welna.com/index/recipe/detail/${$('.jsonld_image').attr('src')}",` +
			`"datePublished": "${$('.jsonld_datePublished').attr('datetime')}",`;
		if ($('.jsonld_author').text()) {
			appendSrc += `"author": { "@type": "Person", "name": "${$('.jsonld_author').text()}"},`;
		} else {
			appendSrc += `"author": { "@type": "Organization", "name": "日清製粉ウェルナ" },`;
		}
		appendSrc += `"mainEntityOfPage": { "@type": "WebPage", "@id": "${location.href}" },`;
		appendSrc += `"description": "${$('.jsonld_description').attr('content')}",` +
			// `"keywords": "${$('.jsonld_keywords').text()}",` +
			`"keywords": "ー",` +
			// `"recipeCategory": "${$('.jsonld_recipeCategory').text()}",` +
			`"recipeCategory": "ー",` +
			`"recipeCuisine": "ー",`;

		if ($('.jsonld_totalTime').length) {
			// totalTime整形
			let totalTimeStr = $('.jsonld_totalTime').text();
			totalTimeStr = totalTimeStr.replace(/時間/, 'H').replace(/分/, 'M').replace(/\+/, '');
			appendSrc += `"cookTime": "PT${totalTimeStr}",`;
		}

		appendSrc +=
			`"recipeYield": "${$('.jsonld_recipeYield').text()}",` +
			`"nutrition": { "calories": "${$('.jsonld_calories').text()}" },`;

		// 材料
		appendSrc += '"recipeIngredient": [';
		$('.jsonld_ingre').each((idx, val) => {
			appendSrc += `"${$(val).find('th').text()} ${$(val).find('td').text()}",`;
		});
		appendSrc = appendSrc.slice(0, -1);
		appendSrc += '],';

		// Howto
		appendSrc += '"recipeInstructions": [';
		if ($('.jsonld_inst_pre').length) {
			appendSrc += `{ "@type": "HowToStep", "text": "（下準備）${$('.jsonld_inst_pre').text()}" },`;
		}
		$('.jsonld_inst').each((idx, val) => {
			appendSrc += `{ "@type": "HowToStep", "text": "（${idx + 1}）${$(val).text()}" },`;
		});
		appendSrc = appendSrc.slice(0, -1);
		appendSrc += ']';

		if ($('.__videoID').length) {
			appendSrc += ',"video": [{ "@type": "VideoObject",' +
				`"name": "${$('.jsonld_name').text()}",` +
				`"description": "${$('.jsonld_description').attr('content')}",` +
				`"thumbnailUrl": [ "http://img.youtube.com/vi/${$('.__videoID').text()}/mqdefault.jpg" ],` +
				`"uploadDate": "${$('.jsonld_datePublished').attr('datetime')}",` +
				`"embedUrl": "https://www.youtube.com/embed/${$('.__videoID').text()}"` +
				'}]';
		}
		appendSrc += '}';

		$('.jsonld-script').append(appendSrc);
	};

	// ＜レシピ詳細＞スライド
	const resipeDetailSlider = () => {
		$('.js-detail-slider li').each((idx,ele) => {
			if(!$(ele).find('img').length) {
				$(ele).remove();
			}
		});
		$('.js-detail-slider').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			customPaging: function(slick,index) {
				let targetImage = slick.$slides.eq(index).find('img').attr('src');
				return '<figure><img src=" ' + targetImage + ' "/></figure>';
			}
		});
	}

	// ＜レシピ詳細＞ 詳細URL指定がある場合リダイレクト
	const recipeDetailRedirect = () => {
		if (!localDecision()) {
			if ($('.rt_cf_detail_page_url').length) {
				location.href = $('.rt_cf_detail_page_url').text();
			}
		}
	};
	// ＜レシピ詳細＞ パンくずの<br>を半角スペースに変換
	const recipeDetailAdjustTopichPath = () => {
		let title = $('.mod-topicPath').find('.rt_cf_recipe_title').html();
		$('.mod-topicPath').find('.rt_cf_recipe_title').html(title.replace(/<br \/>|<br>/g, '&nbsp;'));
	};
	// ＜レシピ詳細＞「One Point」「動画」のブロックを材料ブロックの下に持ってくる処理
	const recipeDetailAdjustBlock = () => {
		// 不要なtable,trを削除
		$('.recipe-detail__ingredients__table').find('table').each((idx, val) => {
			if (!$(val).find('tr').length) {
				$(val).remove();
			}
		});
		$('.__ingredient_name').each((idx, val) => {
			if (!$(val).find('th').length) {
				$(val).remove();
			}
		});

		let $suppleBlock = $('#supplement');
		$(window).on('init resize', () => {
			if ($(window).width() > 768) {
				let ingreH = $('#ingredients').height();
				let howtoH = $('#howto').height();
				if (ingreH < howtoH) {
					$suppleBlock.css({
						position: 'absolute',
						top: ingreH + 100,
						left: 0,
						width: 'calc(50% - 20px)'
					});
					$('#detailAll').css('min-height', ingreH + $('#supplement').height() + 100);
				} else {
					$suppleBlock.css({
						position: 'relative',
						top: 'auto',
						left: 'auto',
						width: 'auto'
					});
				}
			} else {
				$suppleBlock.css({
					position: 'relative',
					top: 'auto',
					left: 'auto',
					width: 'auto'
				});
			}
		});
	};
	// ＜レシピ詳細＞「作り方補足」のスイッチ開閉（初期表示：OPEN）
	const recipeDetailHowtoSwitch = () => {
		if ($('.recipe-detail__howto__sub').length) {
			$('.recipe-detail__howto__sub .__sub_head').on('click', (e) => {
				e.preventDefault();
				$(e.currentTarget).parents('.recipe-detail__howto__sub').toggleClass(o);
				$(e.currentTarget).next('.__sub_body').slideToggle(400);
			});
		}
	};
	// ＜レシピ詳細＞動画セット
	const recipeDetailSetVideo = () => {
		if ($('.__videoID').length) {
			$('.__videoIframe').attr('src', `https://www.youtube.com/embed/${$('.__videoID').text()}`);
		} else {
			$('.recipe-detail__video').remove();
		}
	};
	// ＜レシピ詳細＞使用している商品のカルーセル
	const recipeDetailUseProdSlide = () => {
		let $target = $('.recipe-detail__product__items');
		$target.slick({
			infinite: false,
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [{
				breakpoint: breakpoint,
				settings: {
					slidesToShow: 2,
					prevArrow: arrowPrev,
					nextArrow: arrowNext,
				}
			}]
		});
	};
	// ＜レシピ詳細＞おすすめレシピ
	const recipeDetailRelatedRecipeSlide = () => {
		const getJSONrelatedRecipeList = (_param) => {
			return $.getJSON(`/index/recipe/ajax/recipe/related_recipe.json?${_param}`);
		}
		const randamSortArr = (_Arr) => {
			for (let i = _Arr.length - 1; i > 0; i--) {
				let r = Math.floor(Math.random() * (i + 1));
				let tmp = _Arr[i];
				_Arr[i] = _Arr[r];
				_Arr[r] = tmp;
			}
			return _Arr;
		}
		const setRelatedList = (_data) => {
			// ランダムで10件取得
			_data = randamSortArr(_data);

			let appendHTML = '';
			let cnt = (_data.length > 10) ? 10 : _data.length;
			for (let i = 0; i < cnt; i++) {
				if (appendHTML.indexOf(_data[i].rt_cf_detail_page_url) !== -1 ||
					_data[i].rt_cf_detail_page_url === location.pathname) {
					// 同レシピをふたつ表示しない＆表示中のレシピは除外
					continue;
				}
				appendHTML += `<li><a href="${_data[i].rt_cf_detail_page_url}">` +
					`<img src="${_data[i].rt_cf_thumbnail_src}" alt="${_data[i].rt_cf_title}">` +
					`<p>${_data[i].rt_cf_title}</p></a></li>`;
			}
			$('.recipe-detail__related__items').append(appendHTML);
			$('.recipe-detail__related__items').slick({
				infinite: true,
				slidesToShow: 4,
				slidesToScroll: 1,
				arrows: true,
				dots: false,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							appendArrows: $('.recipe-detail__related__items_arrows'),
						}
					}
				]
			});
		};

		let param = '', paramTemp = '';

		// 埋め込みコードからレシピを取得
		$('.rt_cf_related_repice_staple_foods').each((idx, val) => { // 主食
			if ($(val).text() !== '') { paramTemp += `staplefood=${$(val).text()}`; }
		});
		param += (paramTemp === '') ? 'staplefood=novalue' : paramTemp;
		paramTemp = '';
		$('.rt_cf_related_repice_side_dishes').each((idx, val) => { // おかず
			if ($(val).text() !== '') { paramTemp += `&dish=${$(val).text()}`; }
		});
		param += (paramTemp === '') ? '&dish=novalue' : paramTemp;
		paramTemp = '';

		// まず主食とおかずのみで検索
		if (param !== 'staplefood=novalue&dish=novalue') {
			param += '&theme=novalue&product=novalue';
			getJSONrelatedRecipeList(param).then((data) => {
				if (data.rt_jbn_recipe.length >= 10) {
					setRelatedList(data.rt_jbn_recipe);
				} else {
					let dataTemp = [];
					if (data.rt_jbn_recipe.length) { dataTemp = data.rt_jbn_recipe }

					// 10件未満の場合はテーマと商品を追加して検索
					$('.rt_cf_related_repice_themes').each((idx, val) => { // テーマ
						if ($(val).text() !== '') {
							paramTemp += `&theme=${$(val).text()}`;
						}
					});
					param += (paramTemp === '') ? '&theme=novalue' : paramTemp;
					paramTemp = '';
					$('.rt_cf_related_repice_used_products').each((idx, val) => { // 商品
						if ($(val).text() !== '') {
							paramTemp += `&product=${$(val).text()}`;
						}
					});
					param += (paramTemp === '') ? '&product=novalue' : paramTemp;

					getJSONrelatedRecipeList(param).then((data2) => {
						dataTemp = dataTemp.concat(data2.rt_jbn_recipe);
						if (dataTemp.length) {
							setRelatedList(dataTemp);
						} else {
							$('.recipe-detail__related').remove();
						}
					});
				}
			});
		} else {
			// 主食とおかずがnovalueの場合はテーマと商品を追加
			$('.rt_cf_related_repice_themes').each((idx, val) => { // テーマ
				if ($(val).text() !== '') { paramTemp += `&theme=${$(val).text()}`; }
			});
			param += (paramTemp === '') ? '&theme=novalue' : paramTemp;
			paramTemp = '';
			$('.rt_cf_related_repice_used_products').each((idx, val) => { // 商品
				if ($(val).text() !== '') { paramTemp += `&product=${$(val).text()}`; }
			});
			param += (paramTemp === '') ? '&product=novalue' : paramTemp;

			getJSONrelatedRecipeList(param).then((data) => {
				if (data.rt_jbn_recipe.length) {
					setRelatedList(data.rt_jbn_recipe);
				} else {
					$('.recipe-detail__related').remove();
				}
			});
		}
	};
	// ＜レシピ詳細＞印刷用ページヘのリンク
	const recipeDetailSetLinkPrint = () => {
		$('.js-setPrint').attr('href', `/index/recipe/detail/${location.pathname.split('/')[4].replace(/\.html/, '')}.print.html`);
		window.onload = function() {
			$('.js-setPrint').removeClass('di_none');
		};
	};
	// ＜レシピ詳細＞最近見たレシピ（localstorage登録）
	const setRecentViewedRecipe = () => {// 6個以上は削除
		const recipeID = location.pathname.split('/')[4].replace(/\.html/, '');
		const viewDatetime = new Date();
		let year = viewDatetime.getFullYear();
		let month = viewDatetime.getMonth() + 1; month = ('0' + month).slice(-2);
		let date = viewDatetime.getDate(); date = ('0' + date).slice(-2);
		let hour = viewDatetime.getHours(); hour = ('0' + hour).slice(-2);
		let minute = viewDatetime.getMinutes(); minute = ('0' + minute).slice(-2);
		let second = viewDatetime.getSeconds(); second = ('0' + second).slice(-2);

		localStorage.setItem(`recentRecipe--${recipeID}`, `${year}-${month}-${date} ${hour}:${minute}:${second}`);
	};
	// ＜レシピ詳細＞関連特集0件なら削除
	const removeRelatedFeature = () => {
		if (!$('.recipe-detail__feature').find('li').length) {
			$('.recipe-detail__feature').remove();
		}
	}
	// ＜レシピ詳細＞ 使用している商品　
	const usingProdLabel = () => {
		const getJSONnewProdLabel = (_jancode) => {
			return $.getJSON(`/index/json/${_jancode}/laebels.json`);
		};
		if($('.recipe-detail__product').length) {
			$('.recipe-detail__product').find('.mod-boxLink05').each((idx, ele) => {
				let $thisImgSrc = $(ele).find('img').attr('src').split('/');
				let $thisCode = $thisImgSrc[$thisImgSrc.length -1].split('.')[0];

				getJSONnewProdLabel($thisCode).then((data) => {
					if (data.rt_bn_product.length) {
						let prodData = data.rt_bn_product[0].cf_p_tags;
						for(let i = 0; i < prodData.length; i++) {
							let labelKey = prodData[i]._key;

							if(labelKey === 'new') {
								$(ele).prepend('<span class="mod-boxLink05-new">NEW</span>');
							} else if(labelKey === 'renewal') {
								$(ele).prepend('<span class="mod-boxLink05-renewal">RENEW</span>');
							} else if(labelKey === 'frozen') {
								if($(ele).find('.mod-label-wrap').length) {
									$(ele).find('.mod-label-wrap').append('<span class="_frozen mod-label">冷凍食品</span>')
								} else {
									$(ele).find('.mod-boxLink05-txt').append('<div class="mod-label-wrap mt15">'+
									'<span class="_frozen mod-label">冷凍食品</span></span></div>');
								}
							} else if(labelKey === 'functional') {
								if($(ele).find('.mod-label-wrap').length) {
									$(ele).find('.mod-label-wrap').append('<span class="_function mod-label">機能性表示食品</span>')
								} else {
									$(ele).find('.mod-boxLink05-txt').append('<div class="mod-label-wrap mt15">'+
									'<span class="_function mod-label">機能性表示食品</span></span></div>');
								}
							}
						}
					}
				});
			});
		}
	};

	// <レシピ詳細>同じ食材を使ったレシピ JSON取得用
	const getJSONsameGroceriesRecipe = (_id, _param) => {
		return $.getJSON(`/index/recipe/ajax/recipe/same_groceries/${_id}.json?${_param}`);
	};
	// <レシピ詳細>同じ商品を使ったレシピ JSON取得用
	const getJSONsameProductsRecipe = (_id, _param) => {
		return $.getJSON(`/index/recipe/ajax/recipe/same_product/${_id}.json?${_param}`);
	};
	// <レシピ詳細>同じカテゴリのレシピ JSON取得用
	const getJSONsameCategoryRecipe = (_id, _param) => {
		return $.getJSON(`/index/recipe/ajax/recipe/same_staple_foods/${_id}.json?${_param}`);
	};
	// <レシピ詳細>「同じ食材を使ったレシピ」「同じ商品を使ったレシピ」「同じカテゴリのレシピ」
	const recipeListCreate = () => {
		const $path = location.pathname;
		let recipeId = $path.split('/')[$path.split('/').length -1].replace('.html', '');

		// 同じ食材を使ったレシピ---------------------
		if($('.cf_r_groceries').length) {
			let tagArr = [];
			let tagNameArr = [];
			$('.rt_cf_r_groceries').each((idx, ele) => {
				tagArr.push($(ele).attr('data-rt_code'));
				tagNameArr.push($(ele).text());
			});
			let $param = 'tag_code='+ tagArr.join('&tag_code=');
			getJSONsameGroceriesRecipe(recipeId, $param).then((data) => {
				let recipeList = data.rt_bn_recipe;
				if(recipeList.length) {
					for(let i=0; i<recipeList.length; i++) {
						let _url = recipeList[i].rt_cf_detail_page_url.href;
						let _name = recipeList[i].cf_r_title;
						let _img = recipeList[i].rt_cf_thumbnail.src;
						let _groceries = recipeList[i].cf_r_groceries;
						let groceriesArr = [];
						for(let j=0; j<_groceries.length; j++) {
							let thisGroceriesName = _groceries[j].cf_t_name;
							if(tagNameArr.indexOf(thisGroceriesName) !== -1) {
								groceriesArr.push(thisGroceriesName);
							}
						}
						let recipeHtml = '<li class="pure-u-1-3 pure-u-md-1-2 space-u-40-child">'+
						'<a href="'+_url+'" class="__main">'+
						'<img src="'+_img+'" alt="'+_name+'" class="width-u-100">'+
						'<p class="mt10">'+_name+'</p>'+
						'<p class="mt5 fs_13 color_gray">食材：'+groceriesArr.join('、')+'</p></a></li>';
						$('.js-groceries-output').append(recipeHtml);
					}
				} else {
					$('.js-groceries').addClass('di_none');
				}
			});
		} else {
			$('.js-groceries').addClass('di_none');
		}

		// 同じ商品を使ったレシピ----------------------
		if($('.rt_cf_recipe_used_product_url').length) {
			let prodArr = [];
			$('.rt_cf_recipe_used_product_url').each((idx, ele) => {
				prodArr.push($(ele).attr('data-product_id'));
			});
			let $param = 'product_id='+ prodArr.join('&product_id=');
			getJSONsameProductsRecipe(recipeId, $param).then((data) => {
				let recipeList = data.rt_bn_recipe;
				if(recipeList.length) {
					for(let i=0; i<recipeList.length; i++) {
						let _url = recipeList[i].rt_cf_detail_page_url.href;
						let _name = recipeList[i].cf_r_title;
						let _img = recipeList[i].rt_cf_thumbnail.src;
						let recipeHtml = '<li class="pure-u-1-3 pure-u-md-1-2 space-u-40-child">'+
						'<a href="'+_url+'" class="__main">'+
						'<img src="'+_img+'" alt="'+_name+'" class="width-u-100">'+
						'<p class="mt10">'+_name+'</p></a></li>';
						$('.js-products-output').append(recipeHtml);
					}
				} else {
					$('.js-products').addClass('di_none');
				}
			});
		} else {
			$('.js-products').addClass('di_none');
		}

		// 同じカテゴリのレシピ-------------------------
		if($('.cf_r_staple_foods').length) {
			let catArr = [];
			let catNameArr = [];
			$('.rt_cf_r_staple_foods').each((idx, ele) => {
				catArr.push($(ele).attr('data-rt_code'));
				catNameArr.push($(ele).text());
			});

			if(catArr.length) {
				let $param = 'tag_code='+ catArr.join('&tag_code=');
				getJSONsameCategoryRecipe(recipeId, $param).then((data) => {
					let recipeList = data.rt_bn_recipe;
					if(recipeList.length) {
						let staplefoodArr = [];
						for(let i=0; i<recipeList.length; i++) {
							let _url = recipeList[i].rt_cf_detail_page_url.href;
							let _name = recipeList[i].cf_r_title;
							let _img = recipeList[i].rt_cf_thumbnail.src;
							let _staplefood = recipeList[i].cf_r_staple_foods;
							for(let j=0; j<_staplefood.length; j++) {
								let thisStaplefood = _staplefood[j].cf_t_name;
								if(catNameArr.indexOf(thisStaplefood) !== -1) {
									staplefoodArr.push(thisStaplefood);
								}
							}
							let recipeHtml = '<li class="pure-u-1-3 pure-u-md-1-2 space-u-40-child">'+
							'<a href="'+_url+'" class="__main">'+
							'<img src="'+_img+'" alt="'+_name+'" class="width-u-100">'+
							'<p class="mt10">'+_name+'</p></a></li>';
							$('.js-staple-output').append(recipeHtml);
						}
						let setStaplefoodArr = Array.from(new Set(staplefoodArr));
						$('.js-staple-name').text(setStaplefoodArr.join('、'));
					} else {
						$('.js-staple').addClass('di_none');
					}
				});
			} else {
				$('.js-staple').addClass('di_none');
			}
		} else {
			$('.js-staple').addClass('di_none');
		}

	};
	// <レシピ詳細>「関連特集」がママワザレシピの場合のみバナー表示
	const recipeDetailMamawazaBnr = () => {
		if($('.js-featureHref').length) {
			let featureUrl = $('.js-featureHref').attr('href');
			let featureId = featureUrl.split('/')[featureUrl.split('/').length -1].split('.')[0];
			if(featureId === 'mamawaza') {
				let $path = location.pathname;
				let thisId = $path.split('/')[$path.split('/').length -1].replace('.html', '');
				let $href = $('.js-fanclub-bnr').attr('href') + thisId;
				$('.js-fanclub-bnr').attr('href', $href)
				$('.js-mamawaza').removeClass('di_none');
			}
		}
	};

	// ＜レシピ詳細＞　お気に入りに追加・削除
	const addFavlist = () => {
		if($('.js-recipe-favBtn').length) {
			let $path = location.pathname;
			let recipeId = $path.split('/')[$path.split('/').length -1].replace('.html', '');

			// お気に入り登録済みかチェック
			for(let item in localStorage) {
				if(item.indexOf('favRecipe-') !== -1) {
					if(item.replace(/favRecipe-/, '') === recipeId) {
						$('.js-recipe-favBtn').addClass(a);
						$('.js-recipe-favBtn').find('span').text('お気に入り済');
					}
				}
			}

			$('.js-recipe-favBtn').on('click', (e) => {
				let $this = $(e.currentTarget);

				if(!$this.hasClass(a)) {
					let favoDatetime = new Date();
					favoDatetime = favoDatetime.toLocaleString();
					localStorage.setItem('favRecipe-' + recipeId, favoDatetime);
					$this.addClass(a);
					$this.find('span').text('お気に入り済');
				} else {
					localStorage.removeItem('favRecipe-' + recipeId);
					$this.removeClass(a);
					$this.find('span').text('お気に入りに追加');
				}

				// お気に入り登録数は12まで
				let favoStorage = [];
				let favArr = [];
				for(let i in localStorage) {
					if(i.indexOf('favRecipe-') !== -1) {
						favoStorage.push(i);
					}
				}

				for(let i = 0; i < favoStorage.length; i++) {
					let hash = {
						name: favoStorage[i],
						datetime: localStorage[favoStorage[i]]
					};
					favArr.push(hash);
				}
				favArr.sort(
					function(x, y){
						let xDate = x['datetime'];
						let yDate = y['datetime'];
						if(xDate > yDate) return(1);
						if(xDate < yDate) return(-1);
						return 0;
					}
				);

				if(favoStorage.length > 20) {
					alert('お気に入りに登録できるレシピは最大20件です。');
					localStorage.removeItem(favArr[favArr.length - 1].name);
					favoStorage.pop();
					$this.removeClass(a);
					$this.find('span').text('お気に入りに追加');
					delete favArr[favArr.length -1];
					favArr.pop();
				}
			});
		}
	}
	// ＜お気に入りページ＞　お気に入りリスト描画
	const createBookmarkPage = () => {
		let favoStorage = [];
		let favArr = [];
		let recentStorage = [];
		let recentArr = [];

		for(let i in localStorage) {
			if(i.indexOf('favRecipe-') !== -1) {
				favoStorage.push(i);
			}
			if(i.indexOf('recentRecipe--') !== -1) {
				recentStorage.push(i);
			}
		}
		// お気に入りリスト
		for(let i = 0; i < favoStorage.length; i++) {
			let hash = {
				name: favoStorage[i],
				datetime: localStorage[favoStorage[i]]
			};
			favArr.push(hash);
		}
		// 閲覧リスト
		for(let i = 0; i < recentStorage.length; i++) {
			let hash = {
				name: recentStorage[i],
				datetime: localStorage[recentStorage[i]]
			};
			recentArr.push(hash);
		}

		// 登録日が新しい順にソート
		favArr.sort(
			function(x, y){
				let xDate = x['datetime'];
				let yDate = y['datetime'];
				if(xDate > yDate) return-1;
				if(xDate < yDate) return 1;
				return 0;
			}
		);
		recentArr.sort(
			function(x, y){
				let xDate = x['datetime'];
				let yDate = y['datetime'];
				if(xDate > yDate) return-1;
				if(xDate < yDate) return 1;
				return 0;
			}
		);

		// お気に入りリスト
		if(favArr.length > 0) {
			for (let i = 0; i < favArr.length; i++) {
				let thisKey = favArr[i].name.replace('favRecipe-', '');
				getJSONrecipeDetail(thisKey).then((data) => {
					let recipeData = data.rt_bn_recipe;
					if(recipeData.length) {
						let thisName = recipeData[0].cf_r_title;
						let thisUrl = recipeData[0].rt_cf_detail_page_url;
						let thisImg = '/index'+ recipeData[0].rt_cf_thumbnail;
						let thisTime = recipeData[0].cf_r_cooking_time;
						let thisEnergy = recipeData[0].cf_r_energy;
						let thisSalinity = recipeData[0].cf_r_salinity;
						let infoHtml = '<div class="__item_info">';
						let recipeHtml;
						if(thisTime !== null) { // 「調理時間」
							infoHtml += '<span class="__item_info-time"><svg class="icon">'+
							'<use xlink:href="/index/common/svg/sprite.svg#time"></use></svg><span>'+thisTime+'</span>分</span>';
						}
						if(thisEnergy !== null) { // 「エネルギー」
							infoHtml += '<span class="__item_info-cal"><svg class="icon">'+
							'<use xlink:href="/index/common/svg/sprite.svg#cal"></use></svg><span>'+thisEnergy+'</span>kcal</span>';
						}
						if(thisSalinity !== null) { // 「塩分量」
							infoHtml += '<span class="__item_info-salt"><svg class="icon">'+
							'<use xlink:href="/index/common/svg/sprite.svg#salt"></use></svg><span">'+thisSalinity+'</span>g</span>';
						}
						infoHtml += '</div>';
						// 「調理時間」「エネルギー」「塩分量」全部nullの場合は空にする
						if(thisTime === null && thisEnergy === null && thisSalinity === null) {
							infoHtml = '';
						}
						recipeHtml = '<li class="__item js-create-item" style="order:'+i+';">'+
						'<a href="'+thisUrl+'">'+
						'<div class="__item_img">'+
						'<img src="'+thisImg+'" alt="'+thisName+'" title="'+thisName+'">'+
						'</div><div class="__item_txt">'+
						'<p class="__item_name">'+thisName+'</p>'+
						infoHtml +'</div></a></li>';
						$('.js-favorite-output').append(recipeHtml);
					}
				});
			}
		}
		// 閲覧リスト
		let recentLast = recentArr.length;
		if(recentLast > 6) {
			recentLast = 6;
		}
		if(recentArr.length > 0) {
			for (let i = 0; i < recentLast; i++) {
				let thisKey = recentArr[i].name.replace('recentRecipe--', '');

				getJSONrecipeDetail(thisKey).then((data) => {
					let recipeData = data.rt_bn_recipe;
					if(recipeData.length) {
						let thisName = recipeData[0].cf_r_title;
						let thisUrl = recipeData[0].rt_cf_detail_page_url;
						let thisImg = '/index'+ recipeData[0].rt_cf_thumbnail;
						let thisTime = recipeData[0].cf_r_cooking_time;
						let thisEnergy = recipeData[0].cf_r_energy;
						let thisSalinity = recipeData[0].cf_r_salinity;
						let infoHtml = '<div class="__item_info">';
						let recipeHtml;
						if(thisTime !== null) { // 「調理時間」
							infoHtml += '<span class="__item_info-time"><svg class="icon">'+
							'<use xlink:href="/index/common/svg/sprite.svg#time"></use></svg><span>'+thisTime+'</span>分</span>';
						}
						if(thisEnergy !== null) { // 「エネルギー」
							infoHtml += '<span class="__item_info-cal"><svg class="icon">'+
							'<use xlink:href="/index/common/svg/sprite.svg#cal"></use></svg><span>'+thisEnergy+'</span>kcal</span>';
						}
						if(thisSalinity !== null) { // 「塩分量」
							infoHtml += '<span class="__item_info-salt"><svg class="icon">'+
							'<use xlink:href="/index/common/svg/sprite.svg#salt"></use></svg><span">'+thisSalinity+'</span>g</span>';
						}
						infoHtml += '</div>';
						// 「調理時間」「エネルギー」「塩分量」全部nullの場合は空にする
						if(thisTime === null && thisEnergy === null && thisSalinity === null) {
							infoHtml = '';
						}
						recipeHtml = '<li class="__item js-create-item" style="order:'+i+';">'+
						'<a href="'+thisUrl+'">'+
						'<div class="__item_img">'+
						'<img src="'+thisImg+'" alt="'+thisName+'" title="'+thisName+'">'+
						'</div><div class="__item_txt">'+
						'<p class="__item_name">'+thisName+'</p>'+
						infoHtml +'</div></a></li>';
						$('.js-recent-output').append(recipeHtml);
					}
				});
			}
		}
	}

	// ＜レシピ 特集一覧＞メインヴィジュアル
	$('.recipe-feature-slider').slick({
		infinite: true,
		speed: 1500,
		autoplay: true,
		autoplaySpeed: 5000,
		arrows: false,
		dots: true,
	});

	// ＜共通＞最近見たレシピ（出力）
	const getRecentViewedRecipe = () => {
		// const getJSONrecipeDetail = (_recipeID) => {
		// 	return $.getJSON(`/index/recipe/ajax/recipe/recent/${_recipeID}.json`);
		// }

		let recentStorage = [], recentStorageNew = [];
		let recentList = [];
		for (var i in localStorage) {
			if (i.indexOf('recentRecipe--') !== -1) {
				recentStorage.push({
					id: i.replace(/recentRecipe--/, ''),
					datetime: localStorage[i]
				});
			}
		}
		if (recentStorage.length) {
			recentStorage.sort((x, y) => {
				var xDate = x['datetime'];
				var yDate = y['datetime'];
				if (xDate > yDate) return (-1);
				if (xDate < yDate) return 1;
				return 0;
			});

			let cnt = 0;
			for (let j = 0; j < recentStorage.length; j++) {
				if (cnt < 6 && (new Date(recentStorage[j].datetime) - new Date()) / 86400000 <= 200) { // 6つ以内 & 200日以内
					recentStorageNew.push(recentStorage[j]);
					cnt++;
				} else {
					localStorage.removeItem(`recentRecipe--${recentStorage[j].id}`);
				}
			}
		}
		if (recentStorageNew.length > 0) {
			let p = new Promise((resolve) => {
				let cnt = 0;
				for (let i = 0; i < recentStorageNew.length; i++) {
					getJSONrecipeDetail(recentStorageNew[i].id).then((data) => {
						if (data.rt_bn_recipe.length) {
							if (data.rt_bn_recipe[0].cf_r_status === 1) {
								recentList.push({
									id: recentStorageNew[i].id,
									datetime: recentStorageNew[i].datetime,
									img: data.rt_bn_recipe[0].rt_cf_thumbnail,
									title: data.rt_bn_recipe[0].cf_r_title,
								});
								++cnt;
								if (cnt === recentStorageNew.length) {
									return resolve(recentList);
								}
							} else {
								++cnt;
								if (cnt === recentStorageNew.length) {
									return resolve(recentList);
								}
							}
						} else {
							return resolve(recentList);
						}
					});
				}
			});
			Promise.all([p]).then(() => {
				if (recentList.length) {
					recentList.sort(
						function (x, y) {
							var xDate = x['datetime'];
							var yDate = y['datetime'];
							if (xDate > yDate) return (-1);
							if (xDate < yDate) return 1;
							return 0;
						}
					);
					let recentHTML = '';
					for (let i = 0; i < recentList.length; i++) {
						recentHTML += `<li><a href="/index/recipe/detail/${recentList[i].id}.html">` +
							`<div class="__image"><img src="/index/recipe/detail${recentList[i].img}"></div>` +
							`<div class="__text">${recentList[i].title}</div></a></li>`;
					}

					let $recentList = $('.c-recent-viewed-recipe').find('.c-recipe-list__items');
					$recentList.append(recentHTML);
					$recentList.slick({
						slidesToShow: 6,
						slidesToScroll: 1,
						arrows: true,
						dots: false,
						prevArrow: arrowPrev,
						nextArrow: arrowNext,
						responsive: [{
							breakpoint: 768,
							settings: {
								slidesToShow: 2,
								appendArrows: $('.c-recipe-list__items_arrows'),
							}
						}]
					});
				} else {
					$('.c-recent-viewed-recipe').remove();
				}
			});
		} else {
			$('.c-recent-viewed-recipe').remove();
		}
	};

	// <レシピ 特集>特集レシピ取得用
	const getJSONfeatureRecipeList = (_name) => {
		return $.getJSON(`/index/recipe/ajax/feature/${_name}.json`);
	};
	// <レシピ 特集>特集レシピ
	const featureRecipeList = () => {
		$('.js-feature-block').each((idx, ele) => {
			let thisFeatureName = $(ele).find('.mod-head02-ja').attr('data-rft_code');
			getJSONfeatureRecipeList(thisFeatureName).then((data) => {
				if (data.rt_bn_feature.length) {
					let recipeData = data.rt_bn_feature;
					let recipeHtml;
					// 最初の一個のみ表示
					for(let i = 0; i < 1; i++) {
						let recipeName = recipeData[i].cf_rf_title;
						let recipeImg = recipeData[i].rt_cf_image.src;
						let recipeUrl = recipeData[i].rt_cf_feature_page_url.href;
						recipeHtml = '<li class="pure-u-1-1 space-u-40-child">'+
							'<a href="'+ recipeUrl +'" class="_main">'+
								'<img src="'+recipeImg +'" alt="'+ recipeName +'" class="rt_cf_image" title="'+ recipeName +'">'+
								// '<p>'+ recipeName +'</p>'+
							'</a>'+
						'</li>';
						$(ele).find('.js-feature-output').append(recipeHtml);
					}
				} else {
					$(ele).remove();
				}
			});
		});
	};

	// ＜共通＞一覧系：調理時間、エネルギー、塩分量がひとつも登録されていない場合、__item_infoの線を消す
	const removeBorderItemInfo = () => {
		$('.__item_info').each((idx, val) => {
			if ($(val).find('span').length === 0) {
				$(val).remove();
			}
		});
	};

	// -------------------------------------------------------------------------------- //
	const loadDelayScript = () => {
		searchFormSwitch();
		searchFormCatActivate();
		searchFormReset();
		removeBorderItemInfo();
		searchFormKeyword();
		searchFormKuromoji();
		if ($(window).width() <= 768) {
			searchFormSwitchDetailSP();
		}

		if ($('.c-recent-viewed-recipe').length) {
			getRecentViewedRecipe();
		}

		if (location.pathname === '/index/recipe/' || location.pathname === '/index/recipe/index.html') {
			removeFeatureNonvisible();
			removeNewArrivelRecipes();
			newArrivelRecipesSlide();
			searchByProduct();
			if ($(window).width() <= 768) { searchProdSwicthSP(); }

		} else if (location.pathname.indexOf('search.html') !== -1 || location.pathname.indexOf('sort_time.html') !== -1 ||
			location.pathname.indexOf('sort_energy.html') !== -1 || location.pathname.indexOf('sort_salt.html') !== -1) {
			searchResultSetLabel();
			searchResultSetSort();
			searchResultScroll();
			recipeResultPriority();
		} else if (location.pathname.indexOf('/detail/') !== -1) {
			setJsonld();
			resipeDetailSlider();
			recipeDetailRedirect();
			recipeDetailAdjustTopichPath();
			recipeDetailAdjustBlock();
			recipeDetailHowtoSwitch();
			recipeDetailSetVideo();
			recipeDetailUseProdSlide();
			recipeDetailRelatedRecipeSlide();
			setRecentViewedRecipe();
			removeRelatedFeature();
			usingProdLabel();
			recipeListCreate();
			recipeDetailMamawazaBnr();
			addFavlist();
			recipeDetailSetLinkPrint();
		} else if(location.pathname === '/index/recipe/feature/' || location.pathname === '/index/recipe/feature/index.html') {
			featureRecipeList();
		} else if(location.pathname === '/index/recipe/feature/mamawaza.html') {
			// 「作った写真をシェアしよう！ 簡単おいしい#ママワザ レシピ」の場合バナー表示
			$('.js-mamawaza').removeClass('di_none');
		} else if(location.pathname === '/index/recipe/feature/economiyaki.html') {
			// 「エコのみ焼き」の場合バナー表示
			$('.js-economiyaki').removeClass('di_none');
			$('.js-okotakoBasic').removeClass('di_none');
			$('.js-sdgs').removeClass('di_none');
		} else if(location.pathname === '/index/recipe/bookmark/' || location.pathname === '/index/recipe/bookmark/index.html') {
			createBookmarkPage();
		}
	};
	$(() => localDecision() ? localLoading() : loadDelayScript());

})(window.jQuery);
